import React, { useEffect, useRef, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import styled, { ThemeProvider } from "styled-components";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import theme from "../../style/theme";
import { ImageData } from "../../utils/image/image-data";
import { SwiperNavigation } from "./SwiperNavigation";

interface CustomSwiperProps {
  children?: any;
  onClick?: (e: any) => void;
  onClickLeft?: (e: any) => void;
  onClickRight?: (e: any) => void;
  name?: string;
  prevRef?: React.Ref<HTMLButtonElement>;
  nextRef?: React.Ref<HTMLButtonElement>;
  ref?: React.Ref<HTMLButtonElement>;
  prevClassName?: string;
  nextClassName?: string;
  imgItemsContents: Array<string>;
  selectedImage?: ImageData;
  sx?: object | undefined;
}

interface CustomDivProps {
  rotation?: any;
}

export const LocationImageSwiper: React.FC<CustomSwiperProps> = ({
  sx,
  imgItemsContents,
  selectedImage,
}) => {
  const [scale, setScale] = useState(1);
  const transformRef = useRef<any>(null);
  const [swiper, setSwiper] = useState<SwiperCore>();
  const [activeIndex, setActiveIndex] = useState(0);
  SwiperCore.use([Navigation, Pagination]);

  useEffect(() => {
    if (selectedImage && swiper) {
      const currentIndex = imgItemsContents.findIndex(
        (img) => img === selectedImage?.url
      );
      if (currentIndex !== -1) {
        swiper.slideTo(currentIndex);
      }
    }
  }, [selectedImage, imgItemsContents]);

  const imgItemsArray = [...imgItemsContents];

  const imgItemsList = imgItemsArray.map((item: any, idx: any) => (
    <SwiperSlide key={idx}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img className={`${"column"}`} src={`${item}`} alt="주소" />
      </div>
    </SwiperSlide>
  ));

  //zoom, pan, pitch//transform wrap box
  const transformWrapperBox = (
    <TransformWrapper
      ref={transformRef}
      panning={{ disabled: scale <= 1, velocityDisabled: true }}
      onZoom={(ref) => setScale(ref.state.scale)}
    >
      {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
        <CustomDiv>
          <CustomNavigationBox
            prevClassName="prev"
            nextClassName="next"
            onClickLeft={(e) => {
              resetTransform();
            }}
            onClickRight={(e) => {
              resetTransform();
            }}
            isFirst={activeIndex === 0}
            isLast={activeIndex === imgItemsArray.length - 1}
          />

          <TransformComponent>
            <Swiper
              cssMode={true}
              navigation={{
                prevEl: ".prev",
                nextEl: ".next",
              }}
              style={{
                textAlign: "center",
                height: "100%",
                borderBottomLeftRadius: "8px",
              }}
              pagination={{
                el: ".swiper-pagination",
                type: "fraction",
              }}
              className="mySwiper"
              onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
              modules={[Navigation, Pagination]}
              onSwiper={setSwiper}
            >
              {imgItemsList}
            </Swiper>
          </TransformComponent>
        </CustomDiv>
      )}
    </TransformWrapper>
  );

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <CustomContainer style={sx}>{transformWrapperBox}</CustomContainer>
      </ThemeProvider>
    </React.Fragment>
  );
};

const CustomContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const CustomNavigationBox = styled(SwiperNavigation)`
  position: absolute;
  box-sizing: border-box;
`;

const CustomDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23rem;
  box-sizing: border-box;
  border-bottom-left-radius: 8px;
  background: ${theme.palette.primitives.black};
  border-radius: 0.25rem;

  & .column {
    display: block;
    max-width: 33.375rem;
    max-height: 23rem;
  }

  & .react-transform-wrapper,
  & .react-transform-component {
    margin: 0 auto;
    height: 23rem;
  }

  & .react-transform-component {
    width: 100%;
  }

  & .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
